import { Heading } from '@app/app/_components/Heading/Heading';
import { Paragraph } from '@app/app/_components/Paragraph/Paragraph';
import { useAppParameters } from '@app/app/_context/AppParametersContext/useAppParameters';
import { PA_INSURANCE_STEPS } from '@app/app/esales/personal-accidents/_sections/steps/PA_INSURANCE_STEPS';
import { formatEuroValue } from '@app/infrastructure/application/formatEuroValue';
import { FormState } from '@app/lib/form/contracts/FormState';
import { PurchasePersonalInsuranceResult } from '@app/service/eshop/personal-accidents/actions/purchasePersonalAccidentsInsurance';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

interface Props {
    formState: FormState<PurchasePersonalInsuranceResult>;
    totalPrice: number;
    currentStepKey: string;
}

export function PersonalAccidentsWizardFooter({ formState, totalPrice, currentStepKey }: Props) {
    const { tenant } = useAppParameters();
    const t = useTranslations();
    const parameters = useAppParameters();

    const isPaymentStep =
        currentStepKey === PA_INSURANCE_STEPS.PAYMENT.OPTIONS ||
        currentStepKey === PA_INSURANCE_STEPS.PAYMENT.METHOD_TYPE ||
        currentStepKey === PA_INSURANCE_STEPS.PAYMENT.METHOD;

    return (
        <>
            {totalPrice === 0 ? (
                <div>
                    <div className="text-sm text-neutral-500">{t('eshop.general.selectedInsurance')}</div>
                    <Link
                        target="_blank"
                        href={parameters.eshopPersonalAccidentsInfoUrls.selectedInsurance}
                        className="inline-flex items-end justify-start gap-2">
                        <span className="w-min font-medium underline underline-offset-4 sm:w-fit">
                            {t('eshop.personalAccidents.selectedPersonalAccidents')}
                        </span>
                    </Link>
                </div>
            ) : (
                <div className="flex w-full flex-col md:mr-6 md:flex-row md:items-center md:justify-between">
                    <div className="text-left">
                        <Paragraph isGray size="small" isBold>
                            {formState.data?.offers && isPaymentStep ? t('general.payNow') : t('general.total')}
                        </Paragraph>
                        <Heading className="max-xs:text-lg">
                            {formState.data?.offers && isPaymentStep
                                ? formatEuroValue(formState.data.offers.priceToPayNow ?? 0, tenant)
                                : formatEuroValue(totalPrice, tenant)}
                        </Heading>
                    </div>
                </div>
            )}
        </>
    );
}
